import { useAssetActions } from '../context/AssetActionsContext';
export function useDefaultButtonProps() {
  const {
    layoutUse
  } = useAssetActions();
  switch (layoutUse) {
    default:
    case 'detail-actions':
      return {
        size: 'small',
        use: 'secondary'
      };
    case 'editor-actions':
    case 'hover-actions':
      return {
        size: 'xs',
        use: 'tertiary-light'
      };
  }
}